const normalizePhoneNumber = x => x.replace(/[^\d]/g, '')
const formatPhoneNumber = x =>
  x ? x.replace(/(\d\d\d)(\d\d\d)(\d\d\d\d)/, '($1) $2 - $3') : ''

export { normalizePhoneNumber, formatPhoneNumber }
